export default __webpack_public_path__ + "static/media/glr-7.e21fba2e.webp";